import React, { useEffect } from 'react';
import { Grid, Typography, Button } from '@mui/material';
import { observer } from 'mobx-react';
import { styled } from '@mui/material/styles';
import Rating, { IconContainerProps } from '@mui/material/Rating';
import { TaskModel } from 'domains/models/TaskModel';
import TaskGradeEditPageStore from '../store/TaskGradeEditStore';
import { useMediaQueryState } from '../../../hooks/useMediaQueryState';

const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
    border: '1px solid #2281D0',
  },
  '& .MuiRating-iconFilled p': {
    border: '1px solid #2281D0',
    color: '#000000',
  },
}));

const StyledSpan = styled(Typography)(({ theme }) => ({
  width: '34px',
  height: '34px',
  textAlign: 'center',
  paddingTop: '11px',
  border: '1px solid #dddddd',
  borderRadius: '50%',
  fontFamily: 'Pretendard',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '16px',
  marginLeft: '11px',
}));

const customIcons: {
  [index: string]: {
    icon: React.ReactElement;
    label: string;
  };
} = {
  1: {
    icon: <StyledSpan style={{ marginLeft: '0' }}>1</StyledSpan>,
    label: '1',
  },
  2: {
    icon: <StyledSpan>2</StyledSpan>,
    label: '2',
  },
  3: {
    icon: <StyledSpan>3</StyledSpan>,
    label: '3',
  },
  4: {
    icon: <StyledSpan>4</StyledSpan>,
    label: '4',
  },
  5: {
    icon: <StyledSpan>5</StyledSpan>,
    label: '5',
  },
  6: {
    icon: <StyledSpan>6</StyledSpan>,
    label: '6',
  },
  7: {
    icon: <StyledSpan>7</StyledSpan>,
    label: '7',
  },
};

function IconContainer(props: IconContainerProps) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}

interface Props {
  pageStore: TaskGradeEditPageStore;
}
function TaskGradeEditBodyScore(props: Props) {
  const { pageStore } = props;
  const { isPC } = useMediaQueryState();

  const handleclickRating = (e: any) => {
    pageStore.setScore(e.target.value);
  };

  const StyledButton = styled(Button)(({ theme, value }) => ({
    padding: 0,
    minWidth: '34px',
    height: '34px',
    textAlign: 'center',
    paddingTop: '5px',
    borderRadius: '50%',
    fontFamily: 'Pretendard',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '16px',
    marginLeft: '11px',
    color: 'black',
  }));

  return (
    <>
      <Typography
        style={{
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '14px',
          marginTop: '30px',
          textAlign: isPC ? 'center' : 'inherit',
        }}
      >
        평가 점수
        <Typography
          style={{
            fontWeight: 400,
            marginLeft: 10,
            fontSize: '14px',
            lineHeight: '14px',
            color: 'red',
            display: 'inline',
          }}
        >
          (*필수항목)
        </Typography>
      </Typography>
      <Grid
        container
        style={{
          marginTop: '10px',
          ...(isPC ? { justifyContent: 'center' } : {}),
        }}
      >
        <Grid
          container
          onClick={handleclickRating}
          style={{
            cursor: 'pointer',
            paddingLeft: '0',
            justifyContent: 'center',
          }}
        >
          <StyledButton
            variant='outlined'
            sx={{
              marginLeft: 0,
              marginRight: '2px',
              width: 28,
              height: 33,
              border: pageStore.score === '1' ? '1px solid #2281D0' : '1px solid #dddddd',
            }}
            value={'1'}
          >
            1
          </StyledButton>
          <StyledButton
            variant='outlined'
            sx={{
              marginLeft: '0px',
              marginRight: '2px',
              width: 28,
              height: 33,
              border: pageStore.score === '2' ? '1px solid #2281D0' : '1px solid #dddddd',
            }}
            value={'2'}
          >
            2
          </StyledButton>
          <StyledButton
            variant='outlined'
            sx={{
              marginLeft: '0px',
              marginRight: '2px',
              width: 28,
              height: 33,
              border: pageStore.score === '3' ? '1px solid #2281D0' : '1px solid #dddddd',
            }}
            value={'3'}
          >
            3
          </StyledButton>
          <StyledButton
            variant='outlined'
            sx={{
              marginLeft: '0px',
              marginRight: '2px',
              width: 28,
              height: 33,
              border: pageStore.score === '4' ? '1px solid #2281D0' : '1px solid #dddddd',
            }}
            value={'4'}
          >
            4
          </StyledButton>
          <StyledButton
            variant='outlined'
            sx={{
              marginLeft: '0px',
              marginRight: '2px',
              width: 28,
              height: 33,
              border: pageStore.score === '5' ? '1px solid #2281D0' : '1px solid #dddddd',
            }}
            value={'5'}
          >
            5
          </StyledButton>
          <StyledButton
            variant='outlined'
            sx={{
              marginLeft: '0px',
              marginRight: '2px',
              width: 28,
              height: 33,
              border: pageStore.score === '6' ? '1px solid #2281D0' : '1px solid #dddddd',
            }}
            value={'6'}
          >
            6
          </StyledButton>
          <StyledButton
            variant='outlined'
            sx={{
              marginLeft: 0,
              marginRight: '0px',
              width: 28,
              height: 33,
              border: pageStore.score === '7' ? '1px solid #2281D0' : '1px solid #dddddd',
            }}
            value={'7'}
          >
            7
          </StyledButton>
        </Grid>
      </Grid>
    </>
  );
}

export default observer(TaskGradeEditBodyScore);

// 기존 모바일용 rating
{
  /* <StyledRating
name="grade"
defaultValue={pageStore.assess?.userData?.grade || 0}
max={7}
onChange={pageStore.formik.handleChange}
IconContainerComponent={IconContainer}
getLabelText={(value: number) => customIcons[value].label}
highlightSelectedOnly
/> */
}
